export enum HaulerPdfReportEnum {
  manifest = 'manifest',
  multipleManifest = 'multipleManifest',
}
